import { render } from "./FreightBoxHome.vue?vue&type=template&id=253018fe"
import script from "./FreightBoxHome.vue?vue&type=script&lang=js"
export * from "./FreightBoxHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__